import axios from "axios";
import { serviceBaseUrl } from "./constants";
import {
  LoginCredentials,
  LoginResponse,
  RegisterUserDetails,
} from "../models/authModels";
import { ApiResponse, ApiResponseBlank } from "../models/apiResponse";
import { toast } from "react-toastify";

export const loginUser = async (
  credentials: LoginCredentials
): Promise<ApiResponse<LoginResponse>> => {
  try {
    const response = await axios.post<ApiResponse<LoginResponse>>(
      `${serviceBaseUrl}/login`,
      credentials
    );
    const result = response.data as unknown as ApiResponse<LoginResponse>;
    if (result.result && result.result.role === "admin") {
      toast.error("User not authorized to access this application");
      return {
        code: 999,
        message: "User not authorized to access this application ",
        result: null,
      };
    }
    return result;
  } catch (error) {
    throw new Error("Failed to login user");
  }
};

export const checkForValidToken = async (): Promise<
  ApiResponse<LoginResponse>
> => {
  try {
    const response = await axios.get<ApiResponseBlank>(
      `${serviceBaseUrl}/user/me`
    );
    const result = response.data as unknown as ApiResponse<LoginResponse>;
    if (result.result && result.result.role === "admin") {
      toast.error("User not authorized to access this application");
      return {
        code: 999,
        message: "User not authorized to access this application",
        result: null,
      };
    }
    return result;
  } catch (error) {
    throw new Error("Failed to check token");
  }
};

export const registerUser = async (
  credentials: RegisterUserDetails
): Promise<ApiResponse<LoginResponse>> => {
  try {
    const response = await axios.post<ApiResponse<LoginResponse>>(
      `${serviceBaseUrl}/register`,
      credentials,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const result = response.data as unknown as ApiResponse<LoginResponse>;
    return result;
  } catch (error) {
    throw new Error("Failed to register user");
  }
};

export const resetPasswordService = async (email: string): Promise<{ message: string; code: number }> => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/auth/resetPassword?email=${encodeURIComponent(email)}`);
    return response.data;
  } catch (error) {
    console.error('Error sending Email:', error);
    throw new Error('Failed to reset password. Please try again.');
  }
};

export const updatePasswordAPI = async (token: string, email: string, newPassword: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/auth/updatePassword`, {token, email, newPassword,});
    return response.data;
  } catch (error) {
    console.log('error updating password')
    throw new Error('Failed to update password. Please try again.');
  }
};



export const logoutOnService = async (): Promise<ApiResponseBlank> => {
  try {
    const response = await axios.post<ApiResponseBlank>(
      `${serviceBaseUrl}/logout`
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to logout user");
  }
};

export const verifyToken = async (): Promise<ApiResponse<LoginResponse>> => {
  try {
    const response = await axios.post<ApiResponse<LoginResponse>>(
      `${serviceBaseUrl}/verifyToken`
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to verify token");
  }
}



